import { BaseFetch } from "../main-model";
export default class SubDirectorModel extends BaseFetch {
  getSubDirectorBy = (data) =>
    this.authFetch({
      url: "sub-director/getSubDirectorBy",
      method: "POST",
      body: JSON.stringify(data),
    });
    getSubDirectorByAcademicYear = (data) =>
    this.authFetch({
      url: "sub-director/getSubDirectorByAcademicYear",
      method: "POST",
      body: JSON.stringify(data),
    });
  insertSubDirector = (data) =>
    this.authFetch({
      url: "sub-director/insertSubDirector",
      method: "POST",
      body: JSON.stringify(data),
    });
  updateSubDirectorById = (data) =>
    this.authFetch({
      url: "sub-director/updateSubDirectorById",
      method: "POST",
      body: JSON.stringify(data),
    });
  deleteSubDirectorById = (data) =>
    this.authFetch({
      url: "sub-director/deleteSubDirectorById",
      method: "POST",
      body: JSON.stringify(data),
    });
}
